import React, {memo, useEffect, useState} from "react";
import {HttpService} from "../../../services/HttpService";
import {stepsKeys, TStep} from "../../../components/DocumentGeneration/types";
import EmbeddedPayment from "../../../components/DocumentGeneration/components/EmbeddedPayment/EmbeddedPayment";


type Props = {
    clientSecret: string;
    handlePreviousStep: () => void;
}

function Payment(props: Props): React.ReactElement {
    const {
        clientSecret,
        handlePreviousStep,
    } = props;

    const [showModal, setShowModal] = useState<boolean>(true);
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submission',
      step:"Payment",
      form_id: "public-form-15620"
    });
  },[]);
    return (
        <div className="w-full">
            {
                (clientSecret && showModal) ? (
                    <EmbeddedPayment clientSecret={clientSecret} onClose={handlePreviousStep}/>
                ) : null
            }
        </div>
    )
}

export default memo(Payment);